import { styled } from '@mui/material/styles';
import Typography from '@mui/material/Typography';
import { ReactElement } from 'react';
import { useTranslation } from 'react-i18next';

interface UserNavigationErrorProps {
  code: number;
  description: string;
  actions?: ReactElement;
}

export const Container = styled('div')(() => ({
  display: 'flex',
  alignItems: 'center',
  flexDirection: 'column',
  height: '100%',
  paddingTop: '5%',
}));

export const ErrorDescription = styled(Typography)(({ theme }) => ({
  marginTop: theme.spacing(2),
}));

export const ShortDescription = styled('span')(({ theme }) => ({
  fontSize: theme.typography.h4.fontSize,
}));

export const ActionsContainer = styled('div')(({ theme }) => ({
  marginTop: theme.spacing(2),
}));

const UserNavigationError = ({ code, description, actions }: UserNavigationErrorProps) => {
  const { t } = useTranslation();
  return (
    <Container>
      <div>
        <Typography variant="h3">
          {code}.
          <ShortDescription>
            {t('components.UserNavigationError.shortDescription')}
          </ShortDescription>
        </Typography>
        <ErrorDescription variant="h6" color="text.secondary">
          {description}
        </ErrorDescription>
        <ActionsContainer>{actions}</ActionsContainer>
      </div>
    </Container>
  );
};

export default UserNavigationError;
